/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ManagedCollectionKind = typeof ManagedCollectionKind[keyof typeof ManagedCollectionKind];


export const ManagedCollectionKind = {
  subcategory: 'subcategory',
  editorial: 'editorial',
  personal: 'personal',
} as const;
